import React, { ReactNode } from 'react';

export interface ModalBaseProps {
  children: ReactNode;
  isOpen: boolean;
  onBackdropClick?: () => void;
  isCancelIcon?: boolean;
  onClickCloseIcon?: () => void;
  fullScreen?: boolean;
}

export const ModalBase = ({
  children,
  isOpen,
  onBackdropClick,
  isCancelIcon = false,
  onClickCloseIcon,
  fullScreen = false,
}: ModalBaseProps) =>
  isOpen ? (
    <div
      className={`w-screen h-screen fixed left-0 top-0 flex justify-center items-center z-[999999] ${
        !fullScreen && `p-6`
      }`}
    >
      <div
        data-testid="Modal-backdrop"
        className="w-screen h-screen absolute bg-black/60 left-0 top-0 z-[1]"
        onClick={onBackdropClick}
      ></div>
      <div
        className={`bg-white overflow-y-scroll rounded-lg max-h-full max-w-full px-4 py-6 dark:bg-dark dark:text-grayscale-lighter z-[2] relative ${
          isCancelIcon && 'pt-14'
        } ${fullScreen && 'w-full h-full'}`}
        onClick={e => e.stopPropagation()}
      >
        {isCancelIcon && (
          <span
            onClick={onClickCloseIcon}
            className="cursor-pointer bg-cancel-icon dark:bg-cancel-icon-dark h-4 w-4 block absolute top-5 right-5"
            data-testid="button-close"
          ></span>
        )}

        {children}
      </div>
    </div>
  ) : (
    <></>
  );
